import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './hub_campaign.less'
import Separator from 'components/common/separator'
import Strip from 'components/strip'
import { formatMoney, formatDateExtraShort } from 'client/griffin'
import { campaignUrl } from 'lib/campaign_url'
import { getCampaignTotalValue } from 'lib/campaign'

const i18n = getI18n('components/pages/hub/hub_campaign')

class HubCampaign extends React.Component {
  static propTypes = {
    campaign: PropTypes.object,
  }

  render() {
    let {
      campaign: {
        id,
        can_chip_in,
        title,
        currency,
        background_thumbnail_image,
        background_pan,
        gradient_color,
        current_value,
        moneybox_amount,
        goal,
        end_date,
        pledge,
      },
    } = this.props

    const currentValue = getCampaignTotalValue({
      currentValue: current_value,
      pledge,
    })

    let goalAmountFormatted, goalFormatted
    let currentValueFormatted = formatMoney(currency, currentValue, {
      removeTrailingZeros: false,
    })

    let moneyBoxAmountFormatted = formatMoney(currency, moneybox_amount || 0, {
      removeTrailingZeros: false,
    })

    let reached = false
    const currentValueInt = parseInt(currentValue)
    if (goal) {
      goalAmountFormatted = formatMoney(currency, goal, {
        removeTrailingZeros: false,
      })
      goalFormatted = i18n('of_goal', { goal: goalAmountFormatted })
      reached = parseFloat(currentValue) >= parseFloat(goal)
    } else {
      goalFormatted = i18n('collected_{currentValueInt}', {
        currentValueInt,
      })
    }

    if (reached) {
      currentValueFormatted = formatMoney(currency, currentValue, {
        removeTrailingZeros: true,
      })
      goalAmountFormatted = goalAmountFormatted = formatMoney(currency, goal, {
        removeTrailingZeros: true,
      })
    }

    let endDateFormatted
    if (end_date) {
      endDateFormatted = can_chip_in
        ? i18n('ends_on', { date: formatDateExtraShort(end_date) })
        : i18n('pool_ended')
    }
    const campaignPageUrl = campaignUrl(id, false)

    return (
      <a
        data-pa-click="campaign"
        href={campaignPageUrl}
        styleName="campaign-link"
        tabIndex="0"
      >
        <div styleName="hub-campaign">
          <div styleName="top-part">
            <div styleName="campaign-image">
              <Strip
                backgroundImage={background_thumbnail_image}
                backgroundPan={background_pan}
                gradientColor={gradient_color}
              />
            </div>
            {!reached && (
              <div styleName={`middle-part ${reached ? 'reached' : ''}`}>
                <div styleName="campaign-title" title={title}>
                  {title}
                </div>
                <div styleName="campaign-value">{currentValueFormatted}</div>
                <div styleName="campaign-goal">{goalFormatted}</div>
                {endDateFormatted && (
                  <div styleName="end-date-container">
                    <span styleName="end-date">{endDateFormatted}</span>
                  </div>
                )}
              </div>
            )}
            {reached && (
              <div styleName="reached-overlay">
                <div styleName="reached-rocket" />
                <div styleName="reached-statement">{i18n('reached')}</div>
                <div styleName="reached-campaign-title" title={title}>
                  {title}
                </div>
                <div styleName="reached-amounts">{`${currentValueFormatted} / ${goalAmountFormatted}`}</div>
                {endDateFormatted && (
                  <div styleName="reached-end-date">{endDateFormatted}</div>
                )}
              </div>
            )}
          </div>
          <Separator type="dotted" />
          <div styleName="bottom-part">
            <div styleName="balance-title">{i18n('pool_balance')}</div>
            <div styleName="moneybox-amount">{moneyBoxAmountFormatted}</div>
          </div>
        </div>
      </a>
    )
  }
}

export default cssModules(HubCampaign, styles, { allowMultiple: true })
